export const POWERBI_CCMR_INTERNAL_VIEW =  "powerbi.ccmr_internal.view";
export const POWERBI_DQ_INSIGHTS_VIEW =  "powerbi.dq_insights.view";
export const POWERBI_CCMR_SLA_REPORTING_VIEW =  "powerbi.ccmr_sla_reporting.view";

export const ADMIN_PERMISSION_VIEW =  "admin.permissions.view";
export const ADMIN_PERMISSION_EDIT =  "admin.permissions.edit";
export const LS_DOCUMENTS_VIEW = "ls.documents.view";